import moment from 'moment'
import { object } from 'prop-types'
import React, { createContext, useEffect, useState } from 'react'

export const CalendarArticleContext = createContext({})
export const CALENDAR_ARTICLE_LOCAL_STORAGE_KEY =
  'brand-studio::expandableState'

const CalendarArticleProvider = ({ children }) => {
  const [expandableState, setExpandableState] = useState({})

  const toggleExpandable = id => {
    const isOpen = expandableState[id]
    setExpandableState({ ...expandableState, [id]: !isOpen })
  }

  const retrieveFromLocalStorage = () => {
    const storedState = localStorage.getItem(CALENDAR_ARTICLE_LOCAL_STORAGE_KEY)
    if (storedState) {
      return JSON.parse(storedState)
    }
    return {}
  }

  const storeInLocalStorage = () => {
    localStorage.setItem(
      CALENDAR_ARTICLE_LOCAL_STORAGE_KEY,
      JSON.stringify(expandableState)
    )
  }

  const initExpandableState = ({ data, isCalendarView }) => {
    const ids = data.map(item => item.sys.id)
    // if there is no stored state, set all to false, also if there is a new id added)
    if (
      !Object.keys(expandableState).length ||
      ids.length > Object.keys(expandableState).length
    ) {
      //  set the current month to true if it is a calendar view
      //  if it is a general view, set the first one to true and the rest to false
      const currentMonth = moment().format('MMMM')
      const currentMonthId = data.find(
        item => item.fields.title === currentMonth
      ).id

      if (isCalendarView) {
        const calendarState = ids.reduce((acc, id) => {
          acc[id] = id === currentMonthId
          return acc
        }, {})
        return setExpandableState(calendarState)
      }
      const generalState = ids.reduce((acc, id) => {
        acc[id] = id === ids[0]
        return acc
      }, {})
      return setExpandableState(generalState)
    }
  }

  const isOpen = id => {
    return expandableState[id]
  }

  useEffect(() => {
    const storedState = retrieveFromLocalStorage()
    setExpandableState(storedState)
  }, [])

  useEffect(() => {
    storeInLocalStorage()
  }, [expandableState])

  return (
    <CalendarArticleContext.Provider
      value={{
        expandableState,
        toggleExpandable,
        initExpandableState,
        isOpen,
      }}
    >
      {children}
    </CalendarArticleContext.Provider>
  )
}

CalendarArticleProvider.propTypes = {
  children: object.isRequired,
}

export default CalendarArticleProvider
